export const THEME_KEY = 'THEME_KEY'
